import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function Collaborators() {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.livestockify.com/api/admin/collaborators")
      .then((res) => setImages(res.data))
      .catch(console.error);
  }, []);

  const handleDelete = (id) => {
    axios
      .delete(`https://api.livestockify.com/api/admin/collaborators/${id}`)
      .then(() => setImages((prev) => prev.filter((img) => img.id !== id)));
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-6 md:p-8">
      

        <div className="mb-6 flex flex-col items-center md:flex-row md:justify-between md:items-center gap-3">
  <h1 className="text-base sm:text-lg md:text-xl font-semibold text-green-700 text-center md:text-left">
    Collaborators Images
  </h1>

  <button
    onClick={() => navigate("/uploads/collaborators/add")}
    className="border border-gray-300 px-4 py-1.5 rounded-md text-sm"
  >
    + Add Image
  </button>
</div>


        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {images.map((img) => (
            <div key={img.id} className="border rounded-lg overflow-hidden">
              <img src={img.logoUrl} className="w-full h-44 object-cover" />

              <div className="px-3 py-2 text-sm">
                <p className="text-green-600">Image ID: {img.id}</p>

                <div className="flex justify-end gap-4 mt-1">
                  <button
                    onClick={() =>
                      navigate(`/uploads/collaborators/edit/${img.id}`, {
                        state: { logoUrl: img.logoUrl }, // ✅ PASS DATA
                      })
                    }
                    className="text-green-600 hover:underline"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => handleDelete(img.id)}
                    className="text-red-500 hover:underline"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
